// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal__ETc0HtLaNN{width:540px}`, "",{"version":3,"sources":["webpack://./src/app/components/appModals/components/conversationQueueTransferModal/conversationQueueTransferModal.module.scss"],"names":[],"mappings":"AAAA,mBACE,WAAA","sourcesContent":[".modal {\n  width: 540px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal__ETc0HtLaNN`
};
export default ___CSS_LOADER_EXPORT___;
